import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DepartmentService } from '../../services/jrni/department.service';
import { AlertService } from '../../_alert';
import { NgxSpinnerService } from 'ngx-spinner';
import { BasketService } from '../../services/jrni/basket.service';
import { TranslateService } from '@ngx-translate/core';
import { DatastoreService } from '../../services/datastore.service';
import { ServicesService } from '../../services/jrni/services.service';
import { AvailabilityService } from '../../services/jrni/availability.service';
import { CapitaService } from '../../services/capita.service';
import { ApiService } from '../../services/jrni/api.service';
import { AppConfig } from '../../app.config';
import { environment } from '../../../environments/environment';

@Component({
	selector: 'app-confirmation',
	templateUrl: './confirmation.component.html',
	styleUrls: ['./confirmation.component.scss'],
})
export class ConfirmationComponent implements OnInit {
	selectedDepartment;
	pageTitle: string;
	confirmationPageText: string;
	purchase;
	bookings;
	selectedService;
	selectedLocation;
	address;
	selectedDate;
	selectedSlot;
	client;
	endSlot;
	total;
	extraDetailsPresent;
	bookingSummaryData = [];
	bookingsPlaceholder;
	selectedResource;
	selectedResourceObj: any;
	confirmPayment: boolean = false;
	adminMode: boolean = false;
	bookingNumber;
	agentMode: any;
	showLoginButton = environment.showLoginButton;

	constructor(
		private router: Router,
		private departmentService: DepartmentService,
		private alertService: AlertService,
		private spinner: NgxSpinnerService,
		private basketService: BasketService,
		public translateService: TranslateService,
		private servicesService: ServicesService,
		public datastoreService: DatastoreService,
		private availabilityService: AvailabilityService,
		private capitaService: CapitaService,
		private apiService: ApiService
	) { }

	restartJourney() {
		if (sessionStorage.getItem('journey')) {
			// this.router.navigate(['start/' + sessionStorage.getItem('journey')]);
			window.location.assign('/start/' + sessionStorage.getItem('journey'));
		} else {
			window.location.assign('/departments');
		}
	}

	goToLogin() {
		window.location.href = environment.loginUrl;
	}

	ngOnInit() {
		this.agentMode = localStorage.getItem('agent');
		this.scrollToTop();
		this.spinner.show();
		// Use this.departmentService.getLocation() if the services are set on the children departments
		// Use this.departmentService.get() if the services are set on the parent department
		this.departmentService.getLocation().then(async (selectedDepartment) => {
			if (selectedDepartment === undefined) {
				this.restartJourney();
			} else {
				this.client = {
					first_name: this.datastoreService.booking.first_name,
					last_name: this.datastoreService.booking.last_name,
					email: this.datastoreService.booking.email,
				};
				this.selectedDepartment = await selectedDepartment.$getParent();
				// Get the configurable data
				if (this.selectedDepartment.hasOwnProperty('extra')) {
					// Set the title on the login page to the title from the business question
					this.selectedDepartment.extra.hasOwnProperty(
						'confirmation_page_title'
					)
						? (this.pageTitle =
							this.selectedDepartment.extra.confirmation_page_title)
						: (this.pageTitle = 'Confirmation title not set');
					// Set the extra text on the page to the text taken from the business question
					this.selectedDepartment.extra.hasOwnProperty('confirmation_page_text')
						? (this.confirmationPageText =
							this.selectedDepartment.extra.confirmation_page_text)
						: null;
				}

				// Get the selected service
				this.servicesService.get().then((service) => {
					console.log(service);
					this.selectedService = service;
					this.selectedService.calculated_duration =
						Number(this.datastoreService.extraDuration) +
						Number(this.selectedService.durations[0]);

					if (this.selectedService.extra?.online_payment == 'Yes') {
						this.confirmPayment = true;
					}
					if (this.datastoreService.adminJourney) {
						this.confirmPayment = false;
						this.adminMode = true;
					}

					this.datastoreService.bookingQuestions.forEach((question) => {
						if (this.datastoreService.bookingForm.value[question['id']]) {
							this.bookingSummaryData.push({
								name: question.name,
								answer: this.datastoreService.bookingForm.value[question.id],
								detail_type: question.detail_type,
								price: question.price,
							});
						}
					});
					// Check if the questions contain any other purchase details
					const extraDetails = this.bookingSummaryData.filter(
						(elem) => elem.detail_type !== 'check-price'
					);
					extraDetails.length > 0
						? (this.extraDetailsPresent = true)
						: (this.extraDetailsPresent = false);
					// Calculate purchase total
					const paidItems = this.bookingSummaryData.filter(
						(item) => item.detail_type === 'check-price'
					);
					this.total =
						paidItems.map((items) => items.price).reduce((a, b) => a + b, 0) +
						this.selectedService?.price;
				});

				// Get the selected slot
				if (this.datastoreService.selectedSlot) {
					this.availabilityService.getSelectedSlot().then((slot) => {
						this.selectedSlot = slot;
						console.log(slot);
						this.availabilityService.getEndSlot().then((slot) => {
							this.endSlot = slot;
						});
					});
				}
				// this.selectedSlot = this.datastoreService.selectedSlot;
				// Get the selected location
				// Use this.departmentService.getLocation() if the services are set on the children departments
				// Use this.departmentService.get() if the services are set on the parent department
				this.departmentService.getLocation().then((location) => {
					this.selectedLocation = location;
					location?.$getAddress().then((res) => {
						this.address = res;
					});
				});
				// Get the purchase
				this.basketService.getPurchase().then(
					async (purchase) => {
						this.purchase = purchase;
						// if (!purchase && this.datastoreService.booking) {
						this.bookingsPlaceholder = {
							referenceNo: this.datastoreService.booking.id,
						};

						this.bookingNumber = this.datastoreService.booking.id;
						// comented out 21/11/24 because the HAL client checkout changed and purchase no longer has a $get function
						// } else {
						//   purchase.$get('bookings').then(bookings => {
						//     this.bookings = bookings[0];
						//     this.bookingsPlaceholder = {
						//       referenceNo: this.bookings.id
						//     };
						//   });
						// }
						// try {
						// 	// await this.apiService.sendEmail('CONFIRMED', this.datastoreService.booking, this.datastoreService.booking.email, this.selectedDepartment);
						// 	await this.apiService.resendConfirmation(
						// 		this.selectedLocation,
						// 		this.datastoreService.booking.id
						// 	);
						// } catch (err) {
						// 	console.error(err);
						// }
						// if (this.confirmPayment) {
						//   // confirm booking
						//   await this.capitaService.confirm(this.datastoreService.booking.purchase_id, this.selectedLocation.id, this.datastoreService.purchase.total_price);
						// }
						let booking;
						try {
							booking = JSON.parse(localStorage.getItem('booking'));
						} catch (err) {
							console.error(err);
						}
						try {
							this.selectedResourceObj = JSON.parse(
								localStorage.getItem('resource')
							);
						} catch (err) {
							console.error(err);
						}
						try {
							this.selectedSlot = JSON.parse(localStorage.getItem('date'));
						} catch (err) {
							console.error(err);
						}
						try {
							this.selectedLocation = JSON.parse(
								localStorage.getItem('location')
							);
						} catch (err) {
							console.error(err);
						}
						try {
							this.selectedService = JSON.parse(
								localStorage.getItem('service')
							);
						} catch (err) {
							console.error(err);
						}
						await this.notifyVenueOfBooking(
							booking || this.datastoreService.booking
						);

						await this.sendWelcomeEmail(
							booking || this.datastoreService.booking
						);

						if (!localStorage.getItem('agent')) {
							localStorage.removeItem('auth_token');
						}
						this.spinner.hide();
					},
					(err) => {
						this.alertService.error(
							this.translateService.instant('COMMON.GENERAL_ERR')
						);
						this.spinner.hide();
					}
				);
			}
		});
	}

	// A failed call to bl-api does not throw here. The HTTP interceptor turns any
	// error into empty(), so the promise resolves undefined, and where a method in
	// api.service has its own try/catch it hands back the error message as a
	// string. Either way it looks like a success unless you check.
	private callFailed(result: any): boolean {
		return result === undefined || typeof result === 'string';
	}

	// SUP-2502: a new customer gets JRNI's welcome email, plus an interaction on
	// their timeline. This lives here, not in a checkout hook, because the paid
	// journey never returns to summary.afterCheckout() — the gateway redirect
	// lands on verify-payment, whose own afterCheckout() has no call sites, so
	// online-paying customers got nothing. The confirmation page is the one
	// place both the paid and the free/admin path reach.
	private async sendWelcomeEmail(booking: any): Promise<void> {
		if (!this.datastoreService.clientCreated) return;

		const created = this.datastoreService.createdClient;
		const client = this.purchase?._embedded?.client;
		const memberId =
			created?.id ?? client?.id ?? this.datastoreService.client?.id;
		const memberEmail =
			created?.email ??
			client?.email ??
			this.datastoreService.client?.email ??
			booking?.email;
		if (!memberId) {
			console.warn(
				`[welcome-email] no member id for booking ${booking?.id}, nothing sent`
			);
			return;
		}

		// A journey abandoned at the payment gateway leaves the flag behind, so a
		// later booking in the same tab could send the earlier customer their
		// welcome email. Only send when the stored customer is the one who booked.
		if (
			created?.email &&
			booking?.email &&
			created.email.toLowerCase() !== String(booking.email).toLowerCase()
		) {
			console.warn(
				`[welcome-email] stored customer is not the booker for booking ${booking?.id}, nothing sent`
			);
			this.datastoreService.clientCreated = false;
			return;
		}

		// ngOnInit re-runs on a refresh or a Back-press onto this page.
		const marker = `sup2502_welcome_email_sent:${memberId}`;
		if (localStorage.getItem(marker)) return;

		try {
			const config: any = await this.apiService.getConfig(
				AppConfig.settings.core.company_id
			);
			const ignoreList: any[] =
				config?.journey_config?.welcome_email_ignore_list || [];
			const globalId =
				this.datastoreService.selectedService?.global_id ??
				this.selectedService?.global_id;
			if (ignoreList.includes(globalId)) return;

			const companyId =
				this.selectedLocation?.id ??
				booking?.company_id ??
				this.datastoreService.selectedLocation?.id;
			if (!companyId) return;

			localStorage.setItem(marker, '1');
			const sent = await this.apiService.sendWelcomeEmail(companyId, memberId);
			if (this.callFailed(sent)) {
				throw new Error(`send_welcome_email failed: ${sent}`);
			}
			const logged = await this.apiService.bookingTimeline(
				companyId,
				booking?.purchase_id ?? this.purchase?.id,
				memberId,
				memberEmail,
				config?.journey_config?.welcome_email_subject
			);
			if (this.callFailed(logged)) {
				throw new Error(`interaction log failed: ${logged}`);
			}
			this.datastoreService.clientCreated = false;
		} catch (err) {
			localStorage.removeItem(marker);
			console.error('[welcome-email] failed to send welcome email', err);
			(window as any).newrelic?.noticeError(err, {
				alert: 'welcome_email',
				memberId,
			});
		}
	}

	// NRPO-70: licensed approved venues get their own liquid-template email once
	// the booking is made. This hangs off the confirmation page rather than a
	// checkout hook because both checkout paths converge here — the Capita path
	// books server-side and verify-payment's afterCheckout() is dead code.
	private async notifyVenueOfBooking(booking: any): Promise<void> {
		const marker = `nrpo70_venue_email_sent:${booking?.id}`;
		try {
			const config: any = await this.apiService.getConfig(
				AppConfig.settings.core.company_id
			);
			const venueNotification =
				config?.journey_config?.ceremonies?.venueNotification;
			if (!venueNotification) return;

			// booking.service_id is the child service id (48381/48383); only
			// global_id matches the ids the config is written against.
			const globalId = Number(
				this.datastoreService.selectedService?.global_id ??
					this.selectedService?.global_id
			);
			const serviceIds = (venueNotification.service_ids || []).map(Number);
			if (!globalId || !serviceIds.includes(globalId)) return;

			if (!booking?.id) return;

			// The venue resource lives on the child company the booking sits on,
			// which is the location the journey switched to.
			const companyId =
				booking.company_id ??
				this.selectedLocation?.id ??
				this.datastoreService.selectedLocation?.id;
			if (!companyId) return;

			// localStorage 'resource' is only written on the way out to the payment
			// gateway, so on the free/admin path fall back to the in-memory copy,
			// which survives because that path never reloads the page.
			const resource =
				this.selectedResourceObj ||
				(await this.availabilityService.getSelectedResourceObj());
			const venueEmail =
				resource?.extra?.[venueNotification.resourceExtra || 'venue_email'];
			if (!venueEmail) {
				console.warn(
					`[venue-email] no ${venueNotification.resourceExtra} on resource for booking ${booking.id}`
				);
				return;
			}

			// ngOnInit re-runs on a refresh or Back-press onto the confirmation
			// URL, so dedupe or the venue gets the email twice.
			if (localStorage.getItem(marker)) return;
			localStorage.setItem(marker, '1');

			const subject = venueNotification.subject || 'Venue booking confirmation';
			const from = venueNotification.from;

			await this.apiService.sendVenueBookingEmail(
				companyId,
				booking.id,
				venueEmail,
				from,
				subject,
				venueNotification.template
			);

			if (venueNotification.interactionLog) {
				// NRPO-70: the booking has no client_id of its own, so take the
				// member from the purchase verify-payment stored, or from the
				// customer this journey created. Without one the interactions
				// endpoint answers "Missing client ID".
				const clientId =
					booking.client_id ??
					this.purchase?._embedded?.client?.id ??
					this.datastoreService.client?.id ??
					this.datastoreService.createdClient?.id;
				if (!clientId) {
					console.warn(
						`[venue-email] no client id for booking ${booking.id}, interaction not logged`
					);
					return;
				}
				const logged = await this.apiService.logEmailInteraction(
					companyId,
					booking.purchase_id ?? this.datastoreService.purchase?.id,
					clientId,
					{ to: venueEmail, from, subject, emailType: subject }
				);
				if (this.callFailed(logged)) {
					throw new Error(`venue interaction log failed: ${logged}`);
				}
			}
		} catch (err) {
			localStorage.removeItem(marker);
			console.error('[venue-email] failed to notify venue of booking', err);
			(window as any).newrelic?.noticeError(err, {
				alert: 'venue_booking',
				bookingId: booking?.id,
			});
		}
	}

	// print confirmation page
	print() {
		window.print();
	}

	// Start at the top of the page
	scrollToTop() {
		const scrollToOptions = { top: 0, left: 0, behavior: 'instant' };
		window.scrollTo(scrollToOptions as unknown as ScrollToOptions);
	}
}
